import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../../lib/data";
import { Reveal, Overline } from "../Reveal";

export const ServicesSection = ({ showHeader = true }) => (
  <section className="bg-[#F9F9F8] text-[#050505] py-24 md:py-32 px-6" data-testid="services-section">
    <div className="max-w-6xl mx-auto">
      {showHeader && (
        <div className="max-w-3xl mb-14 md:mb-16">
          <Reveal><Overline>Co robimy</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="text-4xl sm:text-5xl lg:text-[3.5rem] tracking-tightest leading-[1.05] font-semibold">
              Usługi, które porządkują pracę i <span className="font-serif-italic font-normal" style={{ color: "var(--gold)" }}>wspierają rozwój</span> firmy.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-lg text-[#52525B] max-w-2xl leading-relaxed">
              Tworzymy praktyczne rozwiązania cyfrowe, które pomagają lepiej prezentować ofertę, usprawniać komunikację i oszczędzać czas.
            </p>
          </Reveal>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 2) * 0.08} className="h-full">
            <motion.div
              data-testid={`service-card-${i}`}
              whileHover={{ y: -4 }}
              transition={{ type: "spring", stiffness: 300, damping: 22 }}
              className="group h-full min-h-[236px] bg-white border border-black/[0.06] rounded-3xl p-8 md:p-10 flex flex-col"
            >
              <div className="flex items-center justify-between mb-7">
                <div className="h-[52px] w-[52px] rounded-2xl border border-black/10 flex items-center justify-center text-[#050505] transition-colors duration-500 group-hover:border-[var(--gold)] group-hover:text-[var(--gold)]">
                  <s.icon size={22} strokeWidth={1.5} />
                </div>
                <span className="text-xs font-mono text-black/20 group-hover:text-[var(--gold)] transition-colors duration-500">0{i + 1}</span>
              </div>
              <h3 className="text-xl md:text-2xl font-semibold tracking-tight mb-3">{s.title}</h3>
              <p className="text-[15px] text-[#52525B] leading-relaxed">{s.desc}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div
          data-testid="services-cta"
          className="mt-14 md:mt-16 rounded-3xl bg-[#050505] text-white px-8 py-10 md:px-14 md:py-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8"
        >
          <div className="max-w-lg">
            <h3 className="text-2xl sm:text-3xl md:text-4xl tracking-tight font-semibold leading-tight">
              Nie wiesz, od czego <span className="font-serif-italic font-normal" style={{ color: "var(--gold)" }}>zacząć?</span>
            </h3>
            <p className="mt-4 text-white/55 text-base md:text-lg leading-relaxed">
              Opowiedz nam o swojej firmie, a pomożemy Ci wybrać rozwiązanie najlepiej dopasowane do Twoich potrzeb.
            </p>
          </div>
          <Link
            to="/contact"
            data-testid="services-cta-button"
            className="group shrink-0 self-start md:self-auto inline-flex items-center gap-2 rounded-full bg-white text-black font-medium px-6 py-3.5 transition-transform duration-300 hover:-translate-y-0.5"
          >
            Umów bezpłatną konsultację
            <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
